/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AuthVisitorAuthenticationCodeRequestResponseVisitorFromJSON, AuthVisitorAuthenticationCodeRequestResponseVisitorToJSON } from './AuthVisitorAuthenticationCodeRequestResponseVisitor';
export function AuthVisitorSharedLinkSigninResponseFromJSON(json) {
    return AuthVisitorSharedLinkSigninResponseFromJSONTyped(json, false);
}
export function AuthVisitorSharedLinkSigninResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        visitor: !exists(json, 'visitor')
            ? undefined
            : AuthVisitorAuthenticationCodeRequestResponseVisitorFromJSON(json['visitor'])
    };
}
export function AuthVisitorSharedLinkSigninResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        visitor: AuthVisitorAuthenticationCodeRequestResponseVisitorToJSON(value.visitor)
    };
}
